import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import * as styles from "./MainNavAccordionItem-tw-styles"
import Button from "../../../../UI/Button/Button"
import Link from "../../../../UI/Link/Link"
import { gaMenuClick } from "../../../../../constants/gtm.constants"

const MainNavAccordionItem = ({ item, active, onToggle }) => {
  const contentEl = useRef()
  const style = styles["defaultStyle"]

  const [hasInnerChild, setHasInnerChild] = useState(false)
  const [toggleId, setToggleId] = useState([])

  const [hasSecondInnerChild, setHasSecondInnerChild] = useState(false)
  const [secondToggleId, setSecondToggleId] = useState([])

  const handleInnerAccordion = index => {
    if (toggleId.includes(index)) {
      if (!hasInnerChild) {
        setToggleId([...toggleId, index])
      }
      let toggleIdCopy = [...toggleId]
      let closeIndex = toggleIdCopy.indexOf(index)
      toggleIdCopy.splice(closeIndex, 1)
      setToggleId(toggleIdCopy)

      setHasInnerChild(!hasInnerChild)
    } else {
      setToggleId([...toggleId, index])
      setHasInnerChild(true)
    }
  }

  const handleSecondInnerAccordion = index => {
    if (secondToggleId.includes(index)) {
      if (!hasSecondInnerChild) {
        setSecondToggleId([...secondToggleId, index])
      }
      let secondToggleIdCopy = [...secondToggleId]
      let closeIndex = secondToggleIdCopy.indexOf(index)
      secondToggleIdCopy.splice(closeIndex, 1)
      setSecondToggleId(secondToggleIdCopy)

      setHasSecondInnerChild(!hasSecondInnerChild)
    } else {
      setSecondToggleId([...secondToggleId, index])
      setHasSecondInnerChild(true)
    }
  }

  return (
    <li
      className={
        active ? `${style?.mainMobilUlLI} ToggleOpened` : style?.mainMobilUlLI
      }
    >
      {item?.link ? (
        <Link {...item?.link} className={style?.mainMobilUlLIink} gaEventClass={gaMenuClick}
        gaEventLabel={item?.label}>
          {item.label}
        </Link>
      ) : (
        <Button className={style?.mainMobilUlBtn} onClick={onToggle}>
          {item.label}
          <span
            className={active ? "accordianIconSub active" : "accordianIconSub"}
          ></span>
        </Button>
      )}

      <div
        ref={contentEl}
        className={
          active
            ? `${style?.mainMobilUlSUbmenu} ToggleSubOpen`
            : style?.mainMobilUlSUbmenu
        }
      >
        {/* First Level Accordion*/}
        {item?.dropdownItems?.map((item, index1) => {
          if (item?.dropdownItems?.length > 0) {
            return (
              <div key={index1} className={style?.mainMobiSUbmenuDiv}>
                <div
                  onClick={() => handleInnerAccordion(index1)}
                  className={
                    toggleId.includes(index1)
                      ? `${style?.mainMobiSUbmenuSubIcon} active`
                      : style?.mainMobiSUbmenuSubIcon
                  }
                  data-testid={`innerFirstAccordion-${index1}`}
                >
                  {item.label}{" "}
                  <span
                    className={
                      toggleId.includes(index1)
                        ? "accordianIconSub active"
                        : "accordianIconSub"
                    }
                  ></span>
                </div>
                {
                  <div
                    className={
                      toggleId.includes(index1)
                        ? `active ${style?.mainMobiSUbmenuSubWrap}`
                        : `${style?.mainMobiSUbmenuSubWrap}`
                    }
                  >
                    <div className={style?.mainMobiSUbmSubWrapIn}>
                      {/* Second Level Accordion */}
                      {item?.dropdownItems?.map((item, index2) => {
                        if (item?.dropdownItems?.length > 0) {
                          return (
                            <div
                              key={index2}
                              className={style?.mainMobiSUbmSubWrapIn2}
                            >
                              <div
                                onClick={() =>
                                  handleSecondInnerAccordion(index2)
                                } data-testid={`innerSecondAccordion-${index1}`}
                              >
                                {item?.label}
                                <span
                                  className={
                                    secondToggleId.includes(index2)
                                      ? "accordianIconSub active"
                                      : "accordianIconSub"
                                  }
                                ></span>
                              </div>

                              {/* {secondToggleId.includes(index2) && ( */}
                              <div
                                className={
                                  secondToggleId.includes(index2)
                                    ? `${style?.mainMobiSUbmSubWrapIn2In} active`
                                    : style?.mainMobiSUbmSubWrapIn2In
                                }
                              >
                                {/* Third Level Accordion */}
                                {item?.dropdownItems?.map((item, index3) => {
                                  return (
                                    <Link {...item?.link} key={index3} gaEventClass={gaMenuClick}
                                    gaEventLabel={item?.label}>
                                      {item?.label}
                                    </Link>
                                  )
                                })}
                              </div>
                            </div>
                          )
                        } else {
                          return (
                            <div key={index2}>
                              <Link {...item?.link} gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}>{item?.label}</Link>
                            </div>
                          )
                        }
                      })}
                    </div>
                  </div>
                }
              </div>
            )
          } else {
            return (
              <div key={index1}>
                <Link {...item?.link} gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}>{item?.label}</Link>
              </div>
            )
          }
        })}
      </div>
    </li>
  )
}

MainNavAccordionItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.bool,
  onToggle: PropTypes.func,
}

export default MainNavAccordionItem
